<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-11 17:02:40
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-07-21 15:46:02
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/component/orderInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--发票信息详情  -->
<template>
  <div>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">发票类型:</span>
        <span class="e-descriptions-item-content">{{
         Number(currentInvoice.invoiceType)  === 101
            ? '增值税普通发票'
            : '增值税专用发票'
        }}</span>
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">发票抬头:</span>
        <span class="e-descriptions-item-content">{{
          currentInvoice.title
        }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">纳税人识别号:</span>
        <span class="e-descriptions-item-content">{{
          currentInvoice.identificationNumber
        }}</span>
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">注册地址:</span>
        <span class="e-descriptions-item-content">{{
          currentInvoice.address
        }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">注册电话:</span>
        <span class="e-descriptions-item-content">{{
          currentInvoice.telephone
        }}</span>
      </el-col>
      <el-col :span="12">
        <span class="e-descriptions-item-label">开户银行:</span>
        <span class="e-descriptions-item-content">{{
          currentInvoice.bank
        }}</span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <span class="e-descriptions-item-label">银行账户:</span>
        <span class="e-descriptions-item-content">{{
          currentInvoice.bankAccount
        }}</span>
      </el-col>
      <!-- <el-col span="12">
        <span class="e-descriptions-item-label">开户银行:</span>
        <span class="e-descriptions-item-content color-red">￥143123.21</span>
      </el-col> -->
    </el-row>
  </div>
</template>

<script>
import api from '../../../../api/evaluation/index';

export default {
  props: {
    applyId: {
      type: [Number, String],
    },
  },
  data() {
    return {
      currentInvoice: {},
    };
  },

  components: {},

  computed: {},

  created() {
    this.getInvoiceList(this.applyId);
  },
  methods: {
    // 获取发票list
    async getInvoiceList(applyId) {
      let res = await api.queryByApplyId({ applyId });
      if (res.code === '200') {
        this.currentInvoice = res.data.length > 0 ? res.data[0] : {};
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.e-descriptions-item-label,
.e-descriptions-item-content {
  font-size: 14px;
  color: #333;
  line-height: 1;
  &.color-red {
    color: #e50113;
  }
}
.e-descriptions-item-label {
  display: inline-block;
  width: 100px;
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;
}
.el-row {
  line-height: 1;
}
.el-row:not(:last-child) {
  margin-bottom: 20px;
}
.el-col {
  display: flex;
}
</style>
